import { useEffect, useState } from "preact/compat";
import {useBehavioralContext, useUserContext} from "../../../../contexts";

export const useTermAccept = (props) => {
    // Destructured props
    const {handleCurrentStep} = props;

    const [check, setCheck] = useState(false);

    const [{}, {}, {setAcceptedTermUse}] = useUserContext();

    const {
        sidebarCartData,
        handleCart
    } = useBehavioralContext();

    const handleChange = () => {
        setCheck((prevState) => {
            return !prevState;
        });
    }

    const handleClick = () => {
        if (!check) {
            return;
        }

        setAcceptedTermUse(true);

        if (Object.keys(sidebarCartData.lastWarehouseAdded).length > 0) {
            // If the fetched product has the same warehouse as the last one added,
            // then it opens the same warehouse modal component.
            // Otherwise, it just follows as normal.
            if (sidebarCartData.newProductData.productData.variants.find(item => {
                return item.id === sidebarCartData.lastWarehouseAdded.data.id;
            })) {
                handleCart("_", "_", {
                    ...sidebarCartData,
                    isSameWarehouseModalOpen: true,
                    isOpen:                   false
                });

                return;
            }
        }

        handleCurrentStep("picker");
    }

    const convertStringToHtml = (input) => {
        const value = input ? input : "";

        const formattedInput = value
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&');

        const textarea = document.createElement('textarea');
        textarea.innerHTML = formattedInput;

        return textarea.value;
    }

    return {
        check,
        handleChange,
        handleClick,
        convertStringToHtml,
    }
}